import { ValuationStamps } from './ValuationStamps';

export type { TypeValuationStampsProps } from './types';
export default ValuationStamps;
